import store from '../../store';

const meta = {
  requiresLogin: true,
  requiresUserType: store.state.User.accountTypes.staff,
};

export default [
  {
    path: 'matches',
    name: 'matches',
    component() {
      return import(/* webpackChunkName: "staffviews" */ '../../views/Matches/MatchesView.vue');
    },
    meta,
  },
  {
    path: 'match/:id',
    name: 'viewMatch',
    component() {
      return import(/* webpackChunkName: "staffviews" */ '../../views/Matches/MatchView.vue');
    },
    meta,
    props: true,
  },
  // {
  //   path: 'matches/create',
  //   name: 'createMatch',
  //   props: true,
  //   component() {
  //     return import(/* webpackChunkName: "staffviews" */ '../../views/Matches/MatchesView.vue');
  //   },
  //   meta,
  // },
  {
    path: 'match/:id/create-task',
    name: 'createTask',
    component() {
      return import(/* webpackChunkName: "staffviews" */ '../../views/Matches/Tasks/CreateTaskView.vue');
    },
    props: true,
    meta,
  },
  {
    path: 'match/:id/task/:taskid/view',
    name: 'viewTask',
    component() {
      return import(/* webpackChunkName: "staffviews" */ '../../views/Matches/Tasks/TaskDetails.vue');
    },
    props: true,
    meta,
  },
  {
    path: 'match/:id/task/:taskid/review',
    name: 'reviewTask',
    component() {
      return import(/* webpackChunkName: "staffviews" */ '../../views/Matches/Tasks/ReviewTask.vue');
    },
    props: true,
    meta,
  },
  {
    path: 'match/:id/task/:taskid/revert',
    name: 'revertTask',
    component() {
      return import(/* webpackChunkName: "staffviews" */ '../../views/Matches/Tasks/RevertTask.vue');
    },
    props: true,
    meta,
  },
];
